module.exports = __webpack_public_path__ + "static/media/blocker_visionary.7b91c589.png";